import { IMapCenter } from "./common";
import { IChild } from "./case/children";

export interface IChildrenSelector {
  [childId: string]: {
    selected: boolean;
    currentImage: string | undefined;
  }
}

export interface IAlert {
  alertId: string;
  alert: string,
  banned?: boolean;
  caseId: string;
  location: string;
  center: IMapCenter;
  children?: IChild[];
  countryName?: string;
  radius: number;
  expirationDate: any;
  language: string,
  phone: string;
  stop: "Yes" | "No";
  error?: boolean;
  createdAt: number,
  lastUpdate: number,
  closedAt?: number,
  expired?: boolean
  agencyCode: string;
  status?: string;
  childrenSelector?: IChildrenSelector;
}

export const initialAlert: IAlert = {
  caseId: "",
  alert: '',
  alertId: "test",
  location: "",
  center: { lat: 59.955413, lng: 30.337844 },
  radius: 10,
  expirationDate: new Date().getTime(),
  phone: "",
  language: "en",
  stop: "Yes",
  createdAt: 0,
  lastUpdate: 0,
  agencyCode: ''
};

export interface IMetricsContent {
  name: string;
  count: number;
}

export interface IAlertsStatsImpsClicks {
  imps: IMetricsContent[];
  clicks: IMetricsContent[];
}

export interface IAlertsStatsMetrics {
  day: IAlertsStatsImpsClicks;
  country: IAlertsStatsImpsClicks;
  countries: number;
  casesWithAlerts: {
    total: number;
    open: number;
    closed: number;
    avgDaysToCloseACase: number;
    closedPercentage: number;
  },
  stopReasons: IMetricsContent[];
  open: number;
  closed: number;
  total: number;
  avgImpresions: number
  avgClicks: number
}

export const initalAlertsStatsMetrics: IAlertsStatsMetrics = {
  day: {
    clicks: [],
    imps: []
  },
  country: {
    clicks: [],
    imps: []
  },
  casesWithAlerts: {
    total: 0,
    open: 0,
    closed: 0,
    avgDaysToCloseACase: 0,
    closedPercentage: 0
  },
  stopReasons: [],
  closed: 0,
  countries: 0,
  open: 0,
  total: 0,
  avgImpresions: 0,
  avgClicks: 0
}